import { Component, EventEmitter, Output } from '@angular/core';
import { IxellAPIService } from 'src/app/tools/api.service';
import { ErrorService } from 'src/app/tools/error.service';
import { HttpRequest, HttpClient, HttpEventType } from '@angular/common/http';
import { HeaderService } from 'src/app/tools/header.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-importFile',
  templateUrl: './importFile.component.html',
  styleUrls: ['./importFile.component.scss']
})

export class ImportFileComponent {
  public progress: number;
  public message: string;
  @Output() public onUploadFinished = new EventEmitter();

  importSub: any;
  aerosolSub: any;
  colorSub: any;
  userSub: any;

  fileByteArray: string[] = [];
  currentFile: any;
  //temp: FileParameter = new FileParameter();
  constructor(private apiService: IxellAPIService, private errorService: ErrorService, private http: HttpClient, private headerService: HeaderService) { }

  ngOnInit() {
    // Pour afficher la flèche de retour
    this.headerService.changeCanBack(true);
    this.headerService.changeTitle("IxellWebLab");
    this.headerService.changeLogo(null);
  }

  onFileChanged(event: any, file: any) {
    this.currentFile = file.files[0];
    //this.currentFile = file.files[0];
    console.log(file.files[0]);


    console.log(this.currentFile);
  }

  sendShades() {
    console.log("function : sendShades");


    const formData = new FormData();
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    formData.append('file', this.currentFile);
    const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/importTeinteAccessEtJantes", formData, { reportProgress: true });
    this.http.request(uploadReq).subscribe();

    //this.importSub = this.apiService.importTeinteAccessEtJantes().subscribe(data => {

    //}, error => {
    //  this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "importe teintes", new Date().toString());
    //  if (this.importSub != null) this.importSub.unsubscribe();
    //});
  }

  sendAero() {
    console.log("function : sendAero");

    this.aerosolSub = this.apiService.importAerosols().subscribe(data => {

    }, error => {
      this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "import aérosols", new Date().toString());
      if (this.aerosolSub != null) this.aerosolSub.unsubscribe();
    });
  }

  sendColor() {
    const formData = new FormData();
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    formData.append('file', this.currentFile);
    //const uploadReq = new HttpRequest("POST", (window.location.href.includes("services.ixell.dcs2.renault.com")) ? environment.apiRootUrlUnique : environment.apiRoot + "/IxellAPI/ImportColor", formData, { reportProgress: true });
    const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/ImportColor", formData, { reportProgress: true });
    this.http.request(uploadReq).subscribe();
  }

  sendNewUsers() {
    const formData = new FormData();
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    formData.append('file', this.currentFile);
    //const uploadReq = new HttpRequest("POST", (window.location.href.includes("services.ixell.dcs2.renault.com")) ? environment.apiRootUrlUnique : environment.apiRoot + "/IxellAPI/ImportNewLocalAccounts", formData, { reportProgress: true });
    const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/ImportNewLocalAccounts", formData, { reportProgress: true });
    this.http.request(uploadReq).subscribe();

  }

  sendCTCs() {
    const formData = new FormData();
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    formData.append('file', this.currentFile);
    //const uploadReq = new HttpRequest("POST", (window.location.href.includes("services.ixell.dcs2.renault.com")) ? environment.apiRootUrlUnique : environment.apiRoot + "/IxellAPI/ImportCTCs", formData, { reportProgress: true });
    const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/ImportCTCs", formData, { reportProgress: true });
    this.http.request(uploadReq).subscribe();
  }

  updateUnisiteCode() {
    const formData = new FormData();
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    formData.append('file', this.currentFile);
    //const uploadReq = new HttpRequest("POST", (window.location.href.includes("services.ixell.dcs2.renault.com")) ? environment.apiRootUrlUnique : environment.apiRoot + "/IxellAPI/UpdateUnisiteCode", formData, { reportProgress: true });
    const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/UpdateUnisiteCode", formData, { reportProgress: true });
    this.http.request(uploadReq).subscribe();
  }

  updateUnisiteCodeAndStatusAdmin() { // @caroline version temporaire 11/2021
    const formData = new FormData();
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    formData.append('file', this.currentFile);
    //const uploadReq = new HttpRequest("POST", (window.location.href.includes("services.ixell.dcs2.renault.com")) ? environment.apiRootUrlUnique : environment.apiRoot + "/IxellAPI/UpdateUnisiteCodeAndStatusAdmin", formData, { reportProgress: true });
    const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/UpdateUnisiteCodeAndStatusAdmin", formData, { reportProgress: true });
    this.http.request(uploadReq).subscribe();
  }

  sendVersions() {
    const formData = new FormData();
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    formData.append('file', this.currentFile);
    //const uploadReq = new HttpRequest("POST", (window.location.href.includes("services.ixell.dcs2.renault.com")) ? environment.apiRootUrlUnique : environment.apiRoot + "/IxellAPI/ImportScaleVersion", formData, { reportProgress: true });
    const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/ImportScaleVersion", formData, { reportProgress: true });
    this.http.request(uploadReq).subscribe();
  }

  sendColorUser() {
    const formData = new FormData();
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    formData.append('file', this.currentFile);

    console.log(formData);

    //const uploadReq = new HttpRequest("POST", (window.location.href.includes("services.ixell.dcs2.renault.com")) ? environment.apiRootUrlUnique : environment.apiRoot + "/IxellAPI/ImportColor", formData, { reportProgress: true });
    const uploadReq = new HttpRequest("POST", environment.apiRoot + "/IxellAPI/ImportClientsLacour", formData, { reportProgress: true });

    console.log(uploadReq);

    this.http.request(uploadReq).subscribe();
  }

  ngOnDestroy() {
    if (this.importSub != null) this.importSub.unsubscribe();
    if (this.aerosolSub != null) this.aerosolSub.unsubscribe();
    if (this.colorSub != null) this.colorSub.unsubscribe();
  }
}
